<div class="editor-shell" [style.grid-template-columns]="sidebarWidth + 'px 4px minmax(0, 1fr)'">
  @if (saveErrorMessage) {
  <div class="save-error-banner" role="alert">
    <i class="fa fa-exclamation-triangle"></i>
    <span>Error Saving: {{ saveErrorMessage }}</span>
    <button type="button" class="close" (click)="dismissSaveError()">
      <span>&times;</span>
    </button>
  </div>
  }

  <app-editor-sidebar
    [sourceRoutes]="sourceRoutes"
    [metadata]="currentMetadata"
    [selectedSourceComponentId]="selectedSourceComponentId"
    [isDualPane]="isDualPane"
    [isTemplateMode]="isTemplateMode"
    [contentSearchResults]="contentSearchResults"
    [copySourceJsonState]="copySourceJsonState"
    (contentSelected)="selectContent($event)"
    (sidebarItemClicked)="onSidebarItemClicked($event)"
    (orderChanged)="onOrderChanged()"
    (metadataPropertiesOpen)="openMetadataProperties($event)"
    (templateModeToggled)="toggleTemplateMode()"
    (contentSearchChanged)="onContentSearchChanged($event)"
    (importSourceClick)="openImportSourceModal()"
    (copySourceJsonClick)="copySourceJson()">
  </app-editor-sidebar>

  <div class="sidebar-resize-handle" (mousedown)="onResizeStart($event)"></div>

  <main class="editor-main">
    <app-editor-toolbar
      [currentTitle]="currentTitle"
      [currentTypeLabel]="currentTypeLabel"
      [version]="version"
      [mainSaveState]="mainSaveState"
      [saveAsState]="saveAsState"
      [saveState]="saveState"
      [canUndo]="undoRedoService.canUndo()"
      [canRedo]="undoRedoService.canRedo()"
      [isDualPane]="isDualPane"
      [isViewingDiff]="isViewingDiff"
      [showVersionsModal]="showVersionsModal"
      [searchTerm]="searchTerm"
      [showNewTrainingPane]="showNewTrainingPane"
      [hasName]="!!(currentMetadata?.name?.trim())"
      [copySourceJsonState]="copySourceJsonState"
      (undoClick)="undo()"
      (redoClick)="redo()"
      (saveClick)="confirmSave('main')"
      (openSaveAsClick)="openSaveAsModal()"
      (toggleVersionsClick)="toggleVersionsModal()"
      (livePreviewClick)="livePreview()"
      (toggleDualPaneClick)="toggleDualPane()"
      (searchChange)="onSearchChange($event)"
      (copySourceJsonClick)="copySourceJson()"
      (copySourceClick)="copySourceToTarget()"
      (saveNewTrainingClick)="saveNewTraining()"
      (closeNewTrainingClick)="closeNewTrainingPane()">
    </app-editor-toolbar>

    <div class="workspace">
      <div class="canvas-stack" [class.dual-pane]="isDualPane">
        @if (!isDualPane) {
        <app-content-canvas
          [selectedRoute]="selectedSourceRoute"
          [selectedRouteDisplayTitle]="selectedSourceRouteDisplayTitle"
          [selectedComponent]="selectedSourceComponent"
          [selectedComponentDisplayTitle]="selectedSourceComponentDisplayTitle"
          [editorChildItems]="sourceEditorChildItems"
          [editorLevel]="sourceEditorLevel"
          [isEditingEnabled]="!isViewingDiff"
          [isDualPane]="false"
          [searchTerm]="searchTerm"
          (routePropertiesOpen)="openSelectedRouteProperties($event)"
          (componentPropertiesOpen)="openSelectedComponentProperties($event)"
          (orderChanged)="onOrderChanged()">
        </app-content-canvas>
        }

        @if (isDualPane) {
        <section class="content-canvas">
          <div class="canvas-head">
            <div>
              <div class="canvas-kicker">Target</div>
              <div class="canvas-label">{{ targetMetadata?.name || 'New content' }}</div>
            </div>
          </div>
          <div class="canvas-body">
            <app-tree [items]="targetRoutes" [level]="0" [treeType]="'target'"
              [parentItem]="selectedTargetComponent" [isEditingEnabled]="false" [isReorderEnabled]="true"
              [searchTerm]="searchTerm" [isDualPane]="isDualPane" [routeTransferMode]="true"
              (orderChanged)="onOrderChanged()"></app-tree>

            <div class="append-dropzone" cdkDropList [id]="appendDropZoneId" [cdkDropListData]="targetRoutes"
              (cdkDropListDropped)="onAppendRouteDrop($event)">
              <span>Drop here</span>
            </div>
          </div>
        </section>
        }
      </div>
    </div>
  </main>

  <app-properties-panel
    [metadata]="currentMetadata"
    [sourceItems]="sourceItems"
    [targetItems]="targetItems"
    [isViewingDiff]="isViewingDiff"
    (metadataChange)="onMetadataPropertiesChange($event)">
  </app-properties-panel>

  <div class="modal custom-modal" tabindex="-1" role="dialog" [ngClass]="{'show': showResetConfirmation}"
    [style.display]="showResetConfirmation ? 'block' : 'none'">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Reset New Training?</h5>
          <button type="button" class="close" (click)="closeResetModal()">
            <span>&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>This will clear all current progress and start a fresh training. Are you sure you want to proceed?</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="closeResetModal()">Cancel</button>
          <button type="button" class="btn btn-danger" (click)="confirmReset()">Reset & Start New</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal custom-modal" tabindex="-1" role="dialog" [ngClass]="{'show': showSaveOptionsModal}"
    [style.display]="showSaveOptionsModal ? 'block' : 'none'">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content" style="width: 600px;">
        <div class="modal-header">
          <h5 class="modal-title">Save Options</h5>
          <button type="button" class="close" (click)="closeSaveModal()">
            <span>&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group mb-3" style="text-align:left;">
            <label>Name</label>
            <input type="text" class="form-control" [(ngModel)]="currentMetadata.name">
          </div>
          <div *ngIf="!isDualPane">
            <div class="option-row mb-3 d-flex justify-content-between align-items-center">
              <span>Save as child</span>
              <label class="switch">
                <input type="checkbox" [checked]="saveAsChild" (change)="toggleSaveOption('saveAsChild')">
                <span class="slider round"></span>
              </label>
            </div>
            <div class="option-row mb-3 d-flex justify-content-between align-items-center">
              <span>Save as template</span>
              <label class="switch">
                <input type="checkbox" [checked]="saveAsTemplate" (change)="toggleSaveOption('saveAsTemplate')">
                <span class="slider round"></span>
              </label>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="closeSaveModal()">Cancel</button>
          <button type="button" class="btn btn-primary" (click)="confirmSave('saveAs')"
            [disabled]="isSaveModalDisabled()">
            Save
          </button>
        </div>
      </div>
    </div>
  </div>

  <app-build-versions *ngIf="showVersionsModal" [contentId]="contentId" (close)="showVersionsModal = false"
    (selectVersion)="onVersionSelected($event)" (viewDiff)="loadVersionWithDiffs($event)"></app-build-versions>

  <div class="modal custom-modal" tabindex="-1" role="dialog" [ngClass]="{'show': showImportSourceModal}"
    [style.display]="showImportSourceModal ? 'block' : 'none'">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content" style="width: 600px;">
        <div class="modal-header">
          <h5 class="modal-title">Import Source</h5>
          <button type="button" class="close" (click)="closeImportSourceModal()">
            <span>&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>Paste the JSON copied from "Copy source". This will replace the current source tree.</p>
          <textarea class="form-control" rows="14" style="font-family: monospace; font-size: 12px;"
            [(ngModel)]="importSourceText" placeholder="Paste source JSON here..."></textarea>
          <p class="text-danger mt-2" *ngIf="importSourceError">{{ importSourceError }}</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="closeImportSourceModal()">Cancel</button>
          <button type="button" class="btn btn-primary" (click)="confirmImportSource()"
            [disabled]="!importSourceText.trim()">
            Import
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal custom-modal" tabindex="-1" role="dialog" [ngClass]="{'show': showLoadLocationModal}"
    [style.display]="showLoadLocationModal ? 'block' : 'none'">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Load Content</h5>
          <button type="button" class="close" (click)="cancelLoadLocation()">
            <span>&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>Where do you want to load this content?</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="cancelLoadLocation()">Cancel</button>
          <button type="button" class="btn btn-primary" (click)="chooseLoadLocation('source')">Source (Left)</button>
          <button type="button" class="btn btn-info" (click)="chooseLoadLocation('target')">Target (Right)</button>
        </div>
      </div>
    </div>
  </div>
</div>
